import React from 'react';
import { Grid, Typography } from '@mui/material';
import { IRfoSectionProps } from 'app/models/Orders/OrderDetails';
import { useStyles } from './OrderDetailsReportStyles';
import { useTranslation } from 'react-i18next';

type ReportRFODetailsProps = {
  rfoDetails: IRfoSectionProps;
};
export const OrderDetailsReportRFORequirements = (props: ReportRFODetailsProps) => {
  const { classes } = useStyles();
  const rfoDetails = props.rfoDetails;
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.rfoSection.earlyarrivalday')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.dataCell}`}>
          {rfoDetails.earlyArrivalDay}
        </Grid>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.rfoSection.jobdescription')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.dataCell}`}>
          {rfoDetails.jobDescription}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.rfoSection.requiredqualifications')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.alternativeDataCell}`}>
          {rfoDetails.requiredQualifications}
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.rfoSection.internalnotes')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.alternativeDataCell}`}>
          {rfoDetails.notes?.split('\n').length > 1
            ? rfoDetails.notes?.split('\n').map(str => <Typography>{str}</Typography>)
            : rfoDetails.notes}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.rfoSection.preferredqualifications')}:</Typography>
        </Grid>
        <Grid xs={6} md={10} className={`${classes.dataCell}`}>
          {rfoDetails.preferredQualifications?.split('\n').length > 1
            ? rfoDetails.preferredQualifications?.split('\n').map(str => <Typography>{str}</Typography>)
            : rfoDetails.preferredQualifications}
        </Grid>
      </Grid>
    </Grid>
  );
};
